<template>
  <div
    v-if="user"
    class="user"
  >
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('label.showUser') }}
        </h3>
        <div class="pull-right box-tools">
          <a
            class="btn btn-default btn-sm"
            @click="$router.back()"
          >
            <i class="fa fa-arrow-circle-left" /> {{ $t('button.back') }}
          </a>
        </div>
      </div>
      <div class="box-body">
        <ul
          class="nav nav-tabs"
          role="tablist"
        >
          <li
            class="active"
            role="presentation"
          >
            <a
              aria-controls="profile"
              data-toggle="tab"
              href="#profile"
              role="tab"
            >
              <i class="fa fa-user" /> {{ $t('label.profile') }}
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div
            id="profile"
            class="tab-pane active"
            role="tabpanel"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{{ $t('label.avatar') }}</td>
                        <td>
                          <template v-if="user.avatar">
                            <img
                              alt="User Avatar"
                              :src="`${$base_api}/${user.avatar}`"
                            >
                          </template>
                          <template v-else>
                            <img
                              alt="User Avatar"
                              src="/img/avatar.png"
                            >
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.id_card') }}</td>
                        <td>: {{ user.id_card || $t('string.na') }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.loan_officer_access_id') }}</td>
                        <td>: {{ user.loan_officer_access_id || $t('string.na') }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('string.collection_officer_value') }}</td>
                        <td>: {{ user.loandisk_collection_officer || $t('string.na') }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.name') }}</td>
                        <td>: {{ user.name }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.gender') }}</td>
                        <td>: {{ user.gender ? user.gender['name_' + $i18n.locale] : $t('string.na') }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.updatedAt') }}</td>
                        <td>: {{ user.updated_at || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.role') }}</td>
                        <td>
                          <template v-if="user.roles && Array.isArray(user.roles) && user.roles.length">
                            <ul>
                              <li
                                v-for="(role, role_key) in user.roles"
                                :key="role_key"
                              >
                                {{ role['display_name_' + $i18n.locale] || role.name }}
                              </li>
                            </ul>
                          </template>
                          <template v-else>
                            {{ $t('string.na') }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t('label.additionalPermissions') }}</td>
                        <td>
                          <template v-if="user.permissions && Array.isArray(user.permissions) && user.permissions.length">
                            <ul>
                              <li
                                v-for="(permission, permission_key) in user.permissions"
                                :key="permission_key"
                              >
                                {{ permission['display_name_' + $i18n.locale] || role.name }}
                              </li>
                            </ul>
                          </template>
                          <template v-else>
                            {{ $t('string.na') }}
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Show',
  metaInfo () {
    return {
      title: this.$t('label.showUser'),
      titleTemplate: '%s | ' + this.$t('string.appName')
    }
  },
  data () {
    return {
      user: null
    }
  },
  methods: {
    fetchUserByUuid () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/user/get-user-by-uuid', {
        uuid: this.$route.params.uuid
      }).then((response) => {
        this.user = response.data.data
      }).catch(error => {
        this.onResponseError(error)
      })
    }
  },
  mounted () {
    this.fetchUserByUuid()
  }
}
</script>

<style scoped>

</style>
